export interface IStatusPaymentItem {
  icon: string;
  text: string;
}
